import {Box, HStack, Link, Text, VStack} from '@chakra-ui/react';
import {DownloadFileIcon} from '@/components/svg/DownloadFileIcon';
import {HaliRenderOne, useHalState} from '@synako/haligator';
import {State} from '@synako/halitrek';
import {Article} from 'api-types/ffconnect';
import {useTranslation} from 'react-i18next';
import DocumentIcon from '@/components/svg/DocumentIcon';

export const FicheProduitPdfRow: React.FC<{
  url?: string;
  label: string;
  showDocumentIcon?: boolean;
  showDownloadLabel?: boolean;
  mt?: string;
  margin?: string;
  borderColor?: string;
}> = ({
  url,
  label,
  showDocumentIcon = true,
  showDownloadLabel = false,
  mt,
  margin,
  borderColor: borderColorProp,
}) => {
  const disabled = !url;
  const {t} = useTranslation();
  return (
    <HStack
      bg={disabled ? 'gray.75' : 'white'}
      p={4}
      borderRadius='md'
      borderColor={
        borderColorProp ?? (disabled ? 'blue.transparency_300_60' : 'blue.500')
      }
      borderWidth='1px'
      width='100%'
      mt={mt}
      margin={margin}
      justifyContent='space-between'
    >
      <HStack>
        {showDocumentIcon && (
          <Box
            bg='blue.main_transparency_10'
            p={1}
            borderRadius='md'
          >
            <DocumentIcon {...(disabled && {color: 'gray.dark'})} />
          </Box>
        )}
        <VStack
          alignItems='start'
          gap='0'
        >
          <Text
            color={disabled ? 'gray.dark' : 'blue.500'}
            fontSize='xs'
            fontWeight={disabled ? '400' : '700'}
          >
            {label}
          </Text>
          {showDownloadLabel && (
            <Text
              fontSize='2xs'
              color='gray.dark'
            >
              {t('fiche_produit.fiche_produit_pdf.fiche_technique_pdf')}
            </Text>
          )}
        </VStack>
      </HStack>
      {url ? (
        <Link
          href={url}
          target='_blank'
          rel='noopener noreferrer'
          display='flex'
          alignItems='center'
          justifyContent='center'
          gap='2'
          bg='gray.light'
          px='3'
          py='2'
          borderRadius='md'
        >
          <DownloadFileIcon />
          {showDownloadLabel && (
            <Text fontSize='xs'>{t('global.telecharger')}</Text>
          )}
        </Link>
      ) : (
        <Box
          display='flex'
          alignItems='center'
          justifyContent='center'
          bg='gray.light'
          px='3'
          py='1'
          borderRadius='md'
        >
          <DownloadFileIcon color='gray.300' />
        </Box>
      )}
    </HStack>
  );
};

export const FicheProduit: React.FC<{
  articleState: State<Article>;
  showDocumentIcon?: boolean;
  showDownloadLabel?: boolean;
  borderColor?: string;
}> = ({
  articleState,
  showDocumentIcon = false,
  showDownloadLabel = false,
  borderColor,
}) => {
  const mediasState = useHalState(articleState.follow('medias'));
  const {t} = useTranslation();

  return (
    <VStack
      spacing={2}
      alignItems='stretch'
    >
      <HaliRenderOne
        nav={mediasState.navigable.follow('fiche_produit')}
        render={({state: ficheProduitState}) => (
          <FicheProduitPdfRow
            url={ficheProduitState.data.url}
            label={t(
              'fiche_produit.fiche_produit_pdf.telecharger_fiche_produit',
            )}
            showDocumentIcon={showDocumentIcon}
            showDownloadLabel={showDownloadLabel}
            borderColor={borderColor}
            margin='auto'
          />
        )}
        notFound={() => (
          <FicheProduitPdfRow
            label={t(
              'fiche_produit.fiche_produit_pdf.fiche_produit_non_disponible',
            )}
            showDocumentIcon={showDocumentIcon}
            showDownloadLabel={showDownloadLabel}
            borderColor={borderColor}
            margin='auto'
          />
        )}
      />
    </VStack>
  );
};
